var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 25,
    viewBox: "0 0 53 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_5819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8798 0L3.53223 16.922H52.9999V0H10.8798Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5149 10.2741C20.5149 10.2741 20.5129 10.2732 20.512 10.2722C20.4589 10.2415 20.4295 10.2242 20.4295 10.2242C20.4295 10.2242 20.2517 10.4229 20.1624 10.5112C19.9846 10.6849 19.7921 10.8414 19.582 10.9738C19.58 10.9738 19.58 10.9738 19.579 10.9738C19.4956 11.0276 19.4101 11.0785 19.3198 11.1207C19.1273 11.2205 18.9191 11.2973 18.708 11.3501C18.4468 11.4182 18.1787 11.448 17.9076 11.448C17.3272 11.448 16.8097 11.3242 16.357 11.0746C15.9023 10.826 15.5508 10.4738 15.3013 10.0207C15.0627 9.58975 14.938 9.09735 14.9272 8.54353C14.9262 8.51569 14.9262 8.48785 14.9262 8.46002V8.4341C14.9262 7.84572 15.0509 7.32549 15.3013 6.87244C15.5508 6.41844 15.9023 6.0681 16.357 5.81854C16.8097 5.56994 17.3272 5.44516 17.9076 5.44516C18.8641 5.44516 19.6841 5.82718 20.3617 6.59409C20.3863 6.61905 20.4069 6.64496 20.4295 6.67088L22.3562 4.96716C22.0812 4.63026 21.7699 4.33463 21.4213 4.08219C21.111 3.85471 20.7702 3.66274 20.399 3.50245C19.6154 3.16362 18.7335 2.99469 17.7554 2.99469C16.6349 2.99469 15.6283 3.22601 14.7357 3.68865C13.844 4.15226 13.1438 4.79727 12.6332 5.62465C12.1235 6.45107 11.8691 7.38788 11.8691 8.4341V8.46002C11.8691 8.51665 11.8701 8.57328 11.8721 8.62895C11.9015 9.59647 12.1549 10.467 12.6332 11.2436C13.1438 12.069 13.844 12.714 14.7357 13.1776C15.6283 13.6403 16.6349 13.8726 17.7554 13.8726C18.6599 13.8735 19.5702 13.7228 20.399 13.3648C20.5699 13.2919 20.7339 13.2112 20.891 13.1229C21.4616 12.8071 21.9496 12.3992 22.3562 11.901L21.0648 10.7598L20.5149 10.2732V10.2741Z",
    fill: "#1DBADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8324 8.79598C28.4386 8.37365 27.976 8.06458 27.4408 7.86973C26.7672 7.62977 26.1416 7.47812 25.4149 7.3255C24.6921 7.17577 24.1668 7.03179 23.8407 6.89166C23.5147 6.75248 23.3517 6.54323 23.3517 6.26392C23.3517 5.98461 23.4882 5.75808 23.7641 5.58435C24.0391 5.41062 24.4781 5.32328 25.0791 5.32328C25.2794 5.32328 25.4817 5.33479 25.6869 5.35975C25.8706 5.38087 26.0562 5.40774 26.2398 5.45189C27.7649 5.82239 28.4297 6.34167 28.4297 6.34167L28.3394 3.61956C28.2805 3.5946 28.2215 3.57157 28.1616 3.54853C27.8543 3.43143 27.5263 3.33257 27.1757 3.25386C26.5786 3.11852 25.9756 3.04365 25.3638 3.02638C25.136 3.01966 24.8993 3.02158 24.6764 3.03118C23.828 3.06669 23.1003 3.21355 22.4895 3.47078C22.0731 3.64643 21.7186 3.85952 21.423 4.11004C21.2167 4.28377 21.039 4.4767 20.8917 4.68786C20.5352 5.20138 20.3575 5.77632 20.3575 6.41365C20.3575 6.48372 20.3585 6.55379 20.3643 6.62194C20.3977 7.25255 20.5873 7.76127 20.9388 8.14713C21.3258 8.57617 21.7893 8.8862 22.3294 9.08105C22.8705 9.27494 23.5432 9.45635 24.3474 9.6272C25.081 9.78557 25.6143 9.93819 25.9452 10.0822C26.2761 10.2281 26.4421 10.4488 26.4421 10.7473C26.4421 11.3156 25.8608 11.5997 24.699 11.5997C24.1206 11.5997 23.5333 11.5152 22.9363 11.3434C22.9333 11.3434 22.9294 11.3405 22.9225 11.3396C22.8931 11.3328 22.8636 11.3242 22.8332 11.3146C22.4374 11.1965 22.0711 11.0545 21.7362 10.8884C21.7323 10.8856 21.7294 10.8846 21.7254 10.8836C21.5104 10.7886 21.3149 10.6955 21.146 10.612L21.1421 10.6197L21.0665 10.7876L20.1729 12.7496C20.386 12.8964 20.6246 13.0289 20.8917 13.1508C20.8956 13.1517 20.8996 13.1546 20.9054 13.1556C21.2737 13.3216 21.6911 13.4646 22.1605 13.5856C22.9756 13.7948 23.8172 13.9004 24.6823 13.9004C25.7017 13.9004 26.5688 13.7488 27.2808 13.4445C27.5734 13.3197 27.8562 13.1681 28.1145 12.9866C28.1155 12.9866 28.1155 12.9857 28.1174 12.9857C28.414 12.7745 28.6811 12.5221 28.8874 12.2264C29.2438 11.7187 29.4216 11.1505 29.4216 10.5227C29.4216 9.79517 29.2262 9.21927 28.8343 8.79598H28.8324Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9346 11.3434C22.4878 11.9663 21.6472 12.7342 20.9048 13.1556C20.729 13.2564 20.5571 13.337 20.399 13.3917C19.5702 13.7507 18.6599 13.8995 17.7554 13.9004C16.6349 13.9004 15.6283 13.6672 14.7357 13.2045C13.844 12.7409 13.1438 12.0969 12.6332 11.2705C12.151 10.4872 11.8976 9.60801 11.8721 8.62993C11.8701 8.57426 11.8691 8.51763 11.8691 8.461H14.9262C14.9262 8.48883 14.9262 8.51667 14.9272 8.5445C14.938 9.09833 15.0627 9.59073 15.3013 10.0217C15.5508 10.4747 15.9023 10.827 16.357 11.0756C16.8097 11.3252 17.3272 11.449 17.9076 11.449C18.1787 11.449 18.4468 11.4192 18.708 11.3511C18.9191 11.2983 19.1273 11.2215 19.3198 11.1217C19.4101 11.0794 19.4956 11.0286 19.579 10.9748C19.58 10.9748 19.58 10.9748 19.582 10.9748C19.7921 10.8424 19.9846 10.6859 20.1624 10.5122C20.2517 10.4239 20.4285 10.2261 20.4295 10.2252C20.4295 10.2252 20.4589 10.2425 20.512 10.2732C20.5129 10.2732 20.5139 10.2732 20.5149 10.2751C20.6318 10.3423 20.8616 10.4709 21.1454 10.612C21.3143 10.6955 21.5097 10.7886 21.7248 10.8836C21.7287 10.8856 21.7316 10.8865 21.7356 10.8894C22.0832 11.0401 22.9317 11.3444 22.9346 11.3444V11.3434Z",
    fill: "#1DBADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1612 3.25098L34.3548 13.7411H31.0827L27.2764 3.25098H30.0584L32.7188 11.1706L35.3938 3.25098H38.1612Z",
    fill: "#EAF6FE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7583 5.29927C39.7445 5.29927 39.7318 5.29543 39.72 5.28775C39.6886 5.26664 39.6797 5.22441 39.7013 5.19369L40.0932 4.62451L41.8795 2.0387C41.9011 2.00798 41.9433 1.99934 41.9757 2.02046C42.0071 2.04158 42.016 2.08285 41.9944 2.11452L39.8152 5.26952C39.8015 5.28871 39.7799 5.29927 39.7583 5.29927Z",
    fill: "url(#paint0_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7855 7.55296C38.7472 7.55296 38.7168 7.52321 38.7168 7.48577V7.46466L38.7286 7.44642L42.2973 2.2796C42.3189 2.24889 42.3611 2.24025 42.3935 2.26136C42.4249 2.28248 42.4338 2.32375 42.4122 2.35543L38.8454 7.51937C38.8337 7.53857 38.8111 7.552 38.7865 7.552L38.7855 7.55296Z",
    fill: "url(#paint1_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7123 8.50607C38.674 8.50607 38.6436 8.47631 38.6436 8.43888V8.41872L38.6671 8.38321L42.8348 2.34869H42.8712C42.9095 2.34869 42.9409 2.37845 42.9409 2.41588C42.9409 2.4322 42.935 2.44756 42.9242 2.45908L38.7712 8.47343C38.7594 8.49263 38.7368 8.50607 38.7123 8.50607Z",
    fill: "url(#paint2_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8911 9.08971C38.8774 9.08971 38.8646 9.08587 38.8528 9.07819C38.8214 9.05707 38.8125 9.0158 38.8341 8.98413L43.3495 2.44665C43.3711 2.41594 43.4133 2.4073 43.4457 2.42842C43.4772 2.44953 43.486 2.49081 43.4644 2.52248L38.949 9.05995C38.9353 9.07915 38.9137 9.08971 38.8921 9.08971H38.8911Z",
    fill: "url(#paint3_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2866 9.36133C39.2729 9.36133 39.2601 9.35749 39.2483 9.34981C39.2169 9.32869 39.208 9.28742 39.2297 9.25575L43.5319 3.0283C43.5437 3.0091 43.5663 2.99567 43.5908 2.99567C43.6291 2.99567 43.6596 3.02542 43.6596 3.06286V3.08397L39.3445 9.33061C39.3308 9.34981 39.3092 9.36037 39.2876 9.36037L39.2866 9.36133Z",
    fill: "url(#paint4_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6029 9.74908C39.5646 9.74908 39.5342 9.71933 39.5342 9.68189V9.66078L39.546 9.64254L43.368 4.10714L43.4623 3.9718C43.4839 3.94109 43.5261 3.93245 43.5585 3.95356C43.59 3.97468 43.5988 4.01595 43.5772 4.04763L43.4829 4.18393L39.6628 9.71549C39.651 9.73468 39.6285 9.74812 39.6039 9.74812L39.6029 9.74908Z",
    fill: "url(#paint5_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7612 10.3653C39.7475 10.3653 39.7347 10.3615 39.7229 10.3538C39.6915 10.3327 39.6827 10.2914 39.7043 10.2597L43.5538 4.685C43.5754 4.65428 43.6176 4.64564 43.65 4.66676C43.6815 4.68788 43.6903 4.72915 43.6687 4.76082L39.8192 10.3356C39.8054 10.3548 39.7838 10.3653 39.7622 10.3653H39.7612Z",
    fill: "url(#paint6_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.186 10.5947C40.1723 10.5947 40.1595 10.5909 40.1477 10.5832C40.1163 10.5621 40.1075 10.5208 40.1291 10.4891L43.684 5.34247C43.7056 5.31175 43.7478 5.30311 43.7802 5.32423C43.8117 5.34535 43.8205 5.38662 43.7989 5.41829L40.244 10.565C40.2302 10.5842 40.2086 10.5947 40.187 10.5947H40.186Z",
    fill: "url(#paint7_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2459 11.352C40.2322 11.352 40.2184 11.3482 40.2066 11.3405C40.1752 11.3194 40.1673 11.2772 40.1889 11.2465L40.2214 11.2004V11.1937L40.2371 11.1773L43.9364 5.81952C43.958 5.7888 44.0002 5.78016 44.0326 5.80128C44.064 5.8224 44.0729 5.86367 44.0513 5.89535L40.3038 11.3223C40.2901 11.3415 40.2685 11.352 40.2469 11.352H40.2459Z",
    fill: "url(#paint8_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6538 11.6054C40.64 11.6054 40.6273 11.6016 40.6155 11.5939C40.5841 11.5728 40.5752 11.5315 40.5968 11.4998L44.3344 6.08826C44.356 6.05754 44.3983 6.0489 44.4307 6.07002C44.4621 6.09114 44.4709 6.13241 44.4493 6.16408L40.7117 11.5757C40.698 11.5949 40.6764 11.6054 40.6548 11.6054H40.6538Z",
    fill: "url(#paint9_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6411 13.9177C39.6283 13.9177 39.6146 13.9138 39.6028 13.9062C39.5714 13.885 39.5625 13.8438 39.5841 13.8121L40.1419 13.0039L44.5758 6.58258C44.5974 6.55187 44.6396 6.54323 44.672 6.56434C44.7034 6.58546 44.7123 6.62673 44.6907 6.65841L39.6981 13.887C39.6843 13.9062 39.6627 13.9167 39.6411 13.9167V13.9177Z",
    fill: "url(#paint10_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9516 14.3122C39.9379 14.3122 39.9251 14.3083 39.9133 14.3006C39.8819 14.2795 39.8731 14.2383 39.8947 14.2066L44.8048 7.09705C44.8264 7.06633 44.8687 7.05769 44.9011 7.07881C44.9325 7.09992 44.9413 7.1412 44.9197 7.17287L40.0096 14.2824C39.9958 14.3016 39.9742 14.3122 39.9526 14.3122H39.9516Z",
    fill: "url(#paint11_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3159 14.6299C40.3022 14.6299 40.2894 14.626 40.2776 14.6183C40.2462 14.5972 40.2373 14.556 40.2589 14.5243L45.1259 7.47809C45.1475 7.44737 45.1897 7.43873 45.2221 7.45985C45.2535 7.48097 45.2624 7.52224 45.2408 7.55391L40.3738 14.6001C40.3601 14.6193 40.3385 14.6299 40.3169 14.6299H40.3159Z",
    fill: "url(#paint12_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8149 14.7518C40.8012 14.7518 40.7884 14.7479 40.7766 14.7402C40.7452 14.7191 40.7364 14.6778 40.758 14.6462L45.5512 7.70557C45.5728 7.67485 45.6151 7.66621 45.6475 7.68733C45.6789 7.70845 45.6877 7.74972 45.6661 7.78139L40.8729 14.722C40.8591 14.7412 40.8375 14.7518 40.8159 14.7518H40.8149Z",
    fill: "url(#paint13_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2925 14.9063C41.2787 14.9063 41.266 14.9025 41.2542 14.8948C41.2227 14.8737 41.2139 14.8324 41.2355 14.8008L45.8245 8.15674C45.8461 8.12602 45.8884 8.11738 45.9208 8.1385C45.9522 8.15962 45.961 8.20089 45.9394 8.23256L41.3504 14.8766C41.3367 14.8958 41.3151 14.9063 41.2934 14.9063H41.2925Z",
    fill: "url(#paint14_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5932 15.3123C41.5549 15.3123 41.5244 15.2825 41.5244 15.2451V15.224L41.5362 15.2058L46.3638 8.21716C46.3854 8.18645 46.4277 8.17781 46.4601 8.19893C46.4915 8.22004 46.5003 8.26132 46.4787 8.29299L41.6521 15.2797C41.6403 15.2989 41.6177 15.3123 41.5932 15.3123Z",
    fill: "url(#paint15_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9868 15.5888C41.9731 15.5888 41.9603 15.5849 41.9485 15.5773C41.9171 15.5561 41.9082 15.5149 41.9298 15.4832L46.7261 8.53876C46.7477 8.50804 46.7899 8.4994 46.8223 8.52052C46.8537 8.54164 46.8626 8.58291 46.841 8.61458L42.0447 15.559C42.031 15.5782 42.0094 15.5888 41.9878 15.5888H41.9868Z",
    fill: "url(#paint16_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6225 15.513C42.6088 15.513 42.596 15.5091 42.5842 15.5014C42.5528 15.4803 42.544 15.439 42.5656 15.4074L47.1448 8.77679C47.1664 8.74608 47.2086 8.73744 47.241 8.75856C47.2724 8.77967 47.2813 8.82095 47.2597 8.85262L42.6805 15.4832C42.6667 15.5024 42.6451 15.513 42.6235 15.513H42.6225Z",
    fill: "url(#paint17_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6909 14.8113C43.6772 14.8113 43.6644 14.8074 43.6526 14.7997C43.6212 14.7786 43.6123 14.7374 43.6339 14.7057L47.7231 8.78442C47.7447 8.75371 47.7869 8.74507 47.8193 8.76619C47.8508 8.7873 47.8596 8.82858 47.838 8.86025L43.7488 14.7815C43.7351 14.8007 43.7135 14.8113 43.6919 14.8113H43.6909Z",
    fill: "url(#paint18_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4243 14.5934C44.4106 14.5934 44.3978 14.5896 44.386 14.5819C44.3546 14.5608 44.3457 14.5195 44.3673 14.4878L48.212 8.92078C48.2336 8.89006 48.2758 8.88142 48.3082 8.90254C48.3396 8.92366 48.3485 8.96493 48.3269 8.9966L44.4822 14.5637C44.4685 14.5829 44.4469 14.5934 44.4253 14.5934H44.4243Z",
    fill: "url(#paint19_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9829 14.6299C44.9691 14.6299 44.9564 14.626 44.9446 14.6183C44.9132 14.5972 44.9043 14.5559 44.9259 14.5243L48.2314 9.73755C48.253 9.70683 48.2953 9.69819 48.3277 9.71931C48.3591 9.74043 48.3679 9.7817 48.3463 9.81338L45.0408 14.6001C45.0271 14.6193 45.0055 14.6299 44.9839 14.6299H44.9829Z",
    fill: "url(#paint20_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4057 14.8631C45.392 14.8631 45.3792 14.8593 45.3674 14.8516C45.336 14.8305 45.3272 14.7892 45.3488 14.7576L48.1603 10.6859C48.1819 10.6552 48.2242 10.6466 48.2566 10.6677C48.288 10.6888 48.2968 10.7301 48.2752 10.7617L45.4637 14.8334C45.4499 14.8526 45.4283 14.8631 45.4067 14.8631H45.4057Z",
    fill: "url(#paint21_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8032 15.1318C45.7895 15.1318 45.7767 15.128 45.7649 15.1203C45.7335 15.0992 45.7246 15.0579 45.7463 15.0263L46.4278 14.0396C46.4494 14.0088 46.4916 14.0002 46.524 14.0213C46.5564 14.0424 46.5643 14.0837 46.5427 14.1154L45.8612 15.1021C45.8474 15.1213 45.8258 15.1318 45.8042 15.1318H45.8032Z",
    fill: "url(#paint22_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.229 15.3613C46.2152 15.3613 46.2025 15.3574 46.1907 15.3498C46.1593 15.3286 46.1504 15.2874 46.172 15.2557L46.3311 15.0253C46.3527 14.9946 46.395 14.986 46.4274 15.0071C46.4588 15.0282 46.4676 15.0695 46.446 15.1012L46.2869 15.3315C46.2732 15.3507 46.2516 15.3613 46.23 15.3613H46.229Z",
    fill: "url(#paint23_linear_814_5819)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 4.85005C39.7963 4.85005 39.7835 4.84621 39.7717 4.83854C39.7403 4.81742 39.7315 4.77519 39.7531 4.74447L40.1449 4.17529L41.9312 1.58948C41.9528 1.55876 41.9951 1.55012 42.0275 1.57124C42.0589 1.59236 42.0677 1.63363 42.0461 1.6653L39.867 4.8203C39.8533 4.8395 39.8317 4.85005 39.81 4.85005Z",
    fill: "url(#paint24_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8373 7.10374C38.799 7.10374 38.7686 7.07399 38.7686 7.03656V7.01544L38.7803 6.9972L42.349 1.83038C42.3706 1.79967 42.4129 1.79103 42.4453 1.81215C42.4767 1.83326 42.4855 1.87454 42.4639 1.90621L38.8972 7.07015C38.8854 7.08935 38.8628 7.10279 38.8383 7.10279L38.8373 7.10374Z",
    fill: "url(#paint25_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7641 8.05594C38.7258 8.05594 38.6953 8.02618 38.6953 7.98875V7.96859L38.7189 7.93308L42.8866 1.89856H42.9229C42.9612 1.89856 42.9927 1.92831 42.9927 1.96575C42.9927 1.98207 42.9868 1.99742 42.976 2.00894L38.823 8.0233C38.8112 8.0425 38.7886 8.05594 38.7641 8.05594Z",
    fill: "url(#paint26_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9429 8.63951C38.9291 8.63951 38.9163 8.63567 38.9046 8.628C38.8731 8.60688 38.8643 8.56561 38.8859 8.53393L43.4013 1.99646C43.4229 1.96574 43.4651 1.95711 43.4975 1.97822C43.5289 1.99934 43.5378 2.04061 43.5162 2.07229L39.0008 8.60976C38.987 8.62895 38.9654 8.63951 38.9438 8.63951H38.9429Z",
    fill: "url(#paint27_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3393 8.91113C39.3256 8.91113 39.3128 8.90729 39.301 8.89961C39.2696 8.8785 39.2608 8.83723 39.2824 8.80555L43.5846 2.57811C43.5964 2.55891 43.619 2.54547 43.6436 2.54547C43.6819 2.54547 43.7123 2.57523 43.7123 2.61266V2.63378L39.3973 8.88042C39.3835 8.89961 39.3619 8.91017 39.3403 8.91017L39.3393 8.91113Z",
    fill: "url(#paint28_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6547 9.29986C39.6164 9.29986 39.5859 9.27011 39.5859 9.23267V9.21156L39.5977 9.19332L43.4198 3.65792L43.514 3.52258C43.5357 3.49187 43.5779 3.48323 43.6103 3.50435C43.6417 3.52546 43.6505 3.56674 43.6289 3.59841L43.5347 3.73471L39.7146 9.26627C39.7028 9.28546 39.6802 9.2989 39.6557 9.2989L39.6547 9.29986Z",
    fill: "url(#paint29_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.813 9.91514C39.7992 9.91514 39.7865 9.9113 39.7747 9.90362C39.7433 9.8825 39.7344 9.84123 39.756 9.80956L43.6056 4.2348C43.6272 4.20409 43.6694 4.19545 43.7018 4.21656C43.7332 4.23768 43.7421 4.27895 43.7205 4.31063L39.8709 9.88538C39.8572 9.90458 39.8356 9.91514 39.814 9.91514H39.813Z",
    fill: "url(#paint30_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2378 10.1445C40.224 10.1445 40.2113 10.1407 40.1995 10.133C40.1681 10.1119 40.1592 10.0706 40.1808 10.0389L43.7358 4.89227C43.7574 4.86156 43.7996 4.85292 43.832 4.87404C43.8634 4.89515 43.8723 4.93642 43.8507 4.9681L40.2957 10.1148C40.282 10.134 40.2604 10.1445 40.2388 10.1445H40.2378Z",
    fill: "url(#paint31_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2977 10.9018C40.2839 10.9018 40.2702 10.898 40.2584 10.8903C40.227 10.8692 40.2191 10.827 40.2407 10.7963L40.2731 10.7502V10.7435L40.2888 10.7272L43.9881 5.36932C44.0097 5.33861 44.052 5.32997 44.0844 5.35109C44.1158 5.3722 44.1246 5.41348 44.103 5.44515L40.3556 10.8721C40.3419 10.8913 40.3202 10.9018 40.2986 10.9018H40.2977Z",
    fill: "url(#paint32_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7056 11.1562C40.6918 11.1562 40.679 11.1524 40.6673 11.1447C40.6358 11.1236 40.627 11.0823 40.6486 11.0506L44.3862 5.63904C44.4078 5.60832 44.45 5.59968 44.4824 5.6208C44.5139 5.64192 44.5227 5.68319 44.5011 5.71486L40.7635 11.1264C40.7497 11.1456 40.7281 11.1562 40.7065 11.1562H40.7056Z",
    fill: "url(#paint33_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6929 13.4675C39.6801 13.4675 39.6663 13.4636 39.6546 13.456C39.6231 13.4349 39.6143 13.3936 39.6359 13.3619L40.1937 12.5537L44.6275 6.13238C44.6492 6.10167 44.6914 6.09303 44.7238 6.11415C44.7552 6.13526 44.764 6.17654 44.7424 6.20821L39.7498 13.4368C39.7361 13.456 39.7145 13.4665 39.6929 13.4665V13.4675Z",
    fill: "url(#paint34_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0034 13.862C39.9897 13.862 39.9769 13.8581 39.9651 13.8505C39.9337 13.8293 39.9248 13.7881 39.9464 13.7564L44.8566 6.64685C44.8782 6.61614 44.9204 6.6075 44.9528 6.62861C44.9842 6.64973 44.9931 6.691 44.9715 6.72268L40.0613 13.8322C40.0476 13.8514 40.026 13.862 40.0044 13.862H40.0034Z",
    fill: "url(#paint35_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3677 14.1806C40.3539 14.1806 40.3411 14.1768 40.3294 14.1691C40.2979 14.148 40.2891 14.1067 40.3107 14.0751L45.1776 7.02887C45.1992 6.99815 45.2415 6.98952 45.2739 7.01063C45.3053 7.03175 45.3141 7.07302 45.2925 7.1047L40.4256 14.1509C40.4119 14.1701 40.3902 14.1806 40.3686 14.1806H40.3677Z",
    fill: "url(#paint36_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8677 14.3016C40.8539 14.3016 40.8411 14.2978 40.8294 14.2901C40.7979 14.269 40.7891 14.2277 40.8107 14.196L45.604 7.25543C45.6256 7.22472 45.6678 7.21608 45.7002 7.23719C45.7316 7.25831 45.7405 7.29958 45.7189 7.33126L40.9256 14.2719C40.9119 14.2911 40.8903 14.3016 40.8686 14.3016H40.8677Z",
    fill: "url(#paint37_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3442 14.4561C41.3305 14.4561 41.3177 14.4523 41.3059 14.4446C41.2745 14.4235 41.2657 14.3822 41.2873 14.3506L45.8763 7.70654C45.8979 7.67583 45.9401 7.66719 45.9725 7.68831C46.0039 7.70942 46.0128 7.7507 45.9912 7.78237L41.4022 14.4264C41.3884 14.4456 41.3668 14.4561 41.3452 14.4561H41.3442Z",
    fill: "url(#paint38_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6449 14.8622C41.6066 14.8622 41.5762 14.8324 41.5762 14.795V14.7739L41.588 14.7556L46.4156 7.76703C46.4372 7.73631 46.4794 7.72767 46.5118 7.74879C46.5433 7.76991 46.5521 7.81118 46.5305 7.84286L41.7038 14.8295C41.692 14.8487 41.6695 14.8622 41.6449 14.8622Z",
    fill: "url(#paint39_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0395 15.1386C42.0258 15.1386 42.013 15.1347 42.0012 15.1271C41.9698 15.106 41.961 15.0647 41.9826 15.033L46.7788 8.08856C46.8004 8.05785 46.8426 8.04921 46.875 8.07032C46.9065 8.09144 46.9153 8.13271 46.8937 8.16439L42.0975 15.1088C42.0837 15.128 42.0621 15.1386 42.0405 15.1386H42.0395Z",
    fill: "url(#paint40_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6743 15.0637C42.6606 15.0637 42.6478 15.0599 42.636 15.0522C42.6046 15.0311 42.5957 14.9898 42.6173 14.9582L47.1965 8.32758C47.2181 8.29686 47.2604 8.28822 47.2928 8.30934C47.3242 8.33045 47.333 8.37173 47.3114 8.4034L42.7322 15.034C42.7185 15.0532 42.6969 15.0637 42.6753 15.0637H42.6743Z",
    fill: "url(#paint41_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7427 14.362C43.7289 14.362 43.7161 14.3582 43.7044 14.3505C43.6729 14.3294 43.6641 14.2881 43.6857 14.2565L47.7749 8.3352C47.7965 8.30449 47.8387 8.29585 47.8711 8.31697C47.9025 8.33808 47.9114 8.37936 47.8898 8.41103L43.8006 14.3323C43.7869 14.3515 43.7653 14.362 43.7436 14.362H43.7427Z",
    fill: "url(#paint42_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4761 14.1442C44.4623 14.1442 44.4495 14.1404 44.4378 14.1327C44.4063 14.1116 44.3975 14.0703 44.4191 14.0386L48.2637 8.47156C48.2853 8.44084 48.3276 8.4322 48.36 8.45332C48.3914 8.47444 48.4002 8.51571 48.3786 8.54738L44.534 14.1145C44.5203 14.1337 44.4987 14.1442 44.477 14.1442H44.4761Z",
    fill: "url(#paint43_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0347 14.1806C45.0209 14.1806 45.0081 14.1768 44.9964 14.1691C44.9649 14.148 44.9561 14.1067 44.9777 14.0751L48.2832 9.28833C48.3048 9.25761 48.347 9.24898 48.3794 9.27009C48.4109 9.29121 48.4197 9.33248 48.3981 9.36416L45.0926 14.1509C45.0788 14.1701 45.0572 14.1806 45.0356 14.1806H45.0347Z",
    fill: "url(#paint44_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4575 14.4129C45.4438 14.4129 45.431 14.4091 45.4192 14.4014C45.3878 14.3803 45.3789 14.339 45.4005 14.3074L48.2121 10.2357C48.2337 10.205 48.2759 10.1964 48.3083 10.2175C48.3398 10.2386 48.3486 10.2799 48.327 10.3115L45.5154 14.3832C45.5017 14.4024 45.4801 14.4129 45.4585 14.4129H45.4575Z",
    fill: "url(#paint45_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.855 14.6826C45.8412 14.6826 45.8285 14.6788 45.8167 14.6711C45.7852 14.65 45.7764 14.6087 45.798 14.577L46.4795 13.5903C46.5011 13.5596 46.5434 13.551 46.5758 13.5721C46.6082 13.5932 46.616 13.6345 46.5944 13.6662L45.9129 14.6529C45.8992 14.6721 45.8776 14.6826 45.8559 14.6826H45.855Z",
    fill: "url(#paint46_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2807 14.9111C46.267 14.9111 46.2542 14.9072 46.2424 14.8996C46.211 14.8784 46.2022 14.8372 46.2238 14.8055L46.3829 14.5751C46.4045 14.5444 46.4467 14.5358 46.4791 14.5569C46.5105 14.578 46.5194 14.6193 46.4978 14.651L46.3387 14.8813C46.3249 14.9005 46.3033 14.9111 46.2817 14.9111H46.2807Z",
    fill: "url(#paint47_linear_814_5819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 17.6093V25H0L3.20926 17.6093H53Z",
    fill: "#EAF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48421 20.5751C8.38208 20.5108 8.30253 20.4187 8.24656 20.2987C8.19058 20.1797 8.16309 20.0386 8.16309 19.8773C8.16309 19.7161 8.19156 19.575 8.24754 19.456C8.30352 19.3369 8.38404 19.2448 8.48814 19.1795C8.59223 19.1152 8.714 19.0826 8.85443 19.0826C8.9654 19.0826 9.06557 19.1037 9.15297 19.1469C9.24037 19.1901 9.30518 19.2486 9.34741 19.3235L9.22957 19.4358C9.14708 19.312 9.02236 19.2506 8.85738 19.2506C8.70516 19.2506 8.58634 19.3053 8.50188 19.4147C8.41645 19.5241 8.37422 19.6786 8.37422 19.8773C8.37422 20.076 8.41645 20.2286 8.49992 20.339C8.58339 20.4494 8.69927 20.5041 8.84658 20.5041C8.93692 20.5041 9.01352 20.4887 9.07539 20.459C9.13824 20.4292 9.1893 20.3822 9.23055 20.3189L9.34839 20.4312C9.30518 20.5079 9.23939 20.5665 9.15199 20.6087C9.06459 20.651 8.96344 20.6721 8.84756 20.6721C8.70909 20.6721 8.5883 20.6394 8.48617 20.5751H8.48421Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4912 19.1047H10.6994V19.7842H11.4536V19.1047H11.6618V20.65H11.4536V19.9522H10.6994V20.65H10.4912V19.1047Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9287 19.1047H13.4148C13.5867 19.1047 13.7143 19.1392 13.7988 19.2074C13.8832 19.2755 13.9255 19.3792 13.9255 19.5174C13.9255 19.6201 13.899 19.7075 13.8459 19.7794C13.7929 19.8505 13.7202 19.8994 13.6269 19.9244V19.9292C13.6584 19.9493 13.6839 19.9714 13.7035 19.9944C13.7232 20.0175 13.7399 20.0453 13.7536 20.077L13.9913 20.651H13.7674L13.569 20.1519C13.5435 20.0876 13.513 20.0434 13.4767 20.0213C13.4403 19.9992 13.3844 19.9887 13.3078 19.9887H13.1379V20.651H12.9297V19.1056L12.9287 19.1047ZM13.403 19.8226C13.6181 19.8226 13.7261 19.7257 13.7261 19.5308C13.7261 19.4445 13.6986 19.3792 13.6446 19.337C13.5906 19.2947 13.5071 19.2726 13.3962 19.2726H13.1359V19.8226H13.402H13.403Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1445 19.1047H16.0932V19.2726H15.3527V19.7535H16.0146V19.9215H15.3527V20.482H16.0932V20.65H15.1445V19.1047ZM15.3183 18.953C15.2958 18.9319 15.285 18.905 15.285 18.8724C15.285 18.8397 15.2958 18.8129 15.3174 18.7917C15.339 18.7706 15.3675 18.7601 15.4018 18.7601C15.4362 18.7601 15.4627 18.7706 15.4853 18.7917C15.5079 18.8129 15.5187 18.8397 15.5187 18.8724C15.5187 18.905 15.5079 18.9319 15.4853 18.953C15.4627 18.9741 15.4352 18.9847 15.4018 18.9847C15.3684 18.9847 15.3409 18.9741 15.3183 18.953ZM15.7701 18.953C15.7475 18.9319 15.7367 18.905 15.7367 18.8724C15.7367 18.8397 15.7475 18.8129 15.7701 18.7917C15.7927 18.7706 15.8202 18.7601 15.8536 18.7601C15.8869 18.7601 15.9164 18.7706 15.938 18.7917C15.9596 18.8129 15.9704 18.8397 15.9704 18.8724C15.9704 18.905 15.9596 18.9319 15.937 18.953C15.9144 18.9741 15.8869 18.9847 15.8536 18.9847C15.8202 18.9847 15.7927 18.9741 15.7701 18.953Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4133 20.6078C17.3239 20.5656 17.2523 20.5061 17.1973 20.4312L17.3239 20.3074C17.3711 20.3659 17.429 20.4139 17.4997 20.4494C17.5704 20.4859 17.6402 20.5032 17.7099 20.5032C17.7983 20.5032 17.8709 20.4811 17.9259 20.4369C17.9809 20.3928 18.0084 20.3342 18.0084 20.2623C18.0084 20.2152 17.9986 20.1739 17.9799 20.1384C17.9613 20.1029 17.9289 20.0693 17.8827 20.0357C17.8366 20.0031 17.7718 19.9666 17.6873 19.9263C17.5262 19.8495 17.4133 19.7775 17.3475 19.7084C17.2817 19.6403 17.2493 19.5606 17.2493 19.4685C17.2493 19.3504 17.2925 19.2563 17.3799 19.1863C17.4673 19.1152 17.5832 19.0807 17.7276 19.0807C17.8287 19.0807 17.921 19.1018 18.0045 19.145C18.088 19.1882 18.1489 19.2448 18.1862 19.3168L18.0506 19.4138C18.0143 19.3619 17.9682 19.3216 17.9102 19.2919C17.8533 19.2621 17.7924 19.2477 17.7295 19.2477C17.6451 19.2477 17.5783 19.2669 17.5292 19.3063C17.4801 19.3456 17.4555 19.3974 17.4555 19.4637C17.4555 19.503 17.4644 19.5376 17.483 19.5654C17.5007 19.5932 17.5351 19.622 17.5832 19.6528C17.6323 19.6825 17.7089 19.7238 17.815 19.7756C17.9583 19.8447 18.0605 19.9158 18.1223 19.9887C18.1842 20.0616 18.2146 20.1471 18.2146 20.2459C18.2146 20.3294 18.193 20.4033 18.1498 20.4677C18.1066 20.532 18.0467 20.5809 17.9691 20.6164C17.8916 20.6519 17.8012 20.6692 17.6991 20.6692C17.597 20.6692 17.5007 20.6481 17.4113 20.6049L17.4133 20.6078Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6073 20.5751C19.5051 20.5108 19.4256 20.4187 19.3696 20.2987C19.3136 20.1797 19.2861 20.0386 19.2861 19.8773C19.2861 19.7161 19.3146 19.575 19.3706 19.456C19.4266 19.3369 19.5071 19.2448 19.6112 19.1795C19.7153 19.1152 19.837 19.0826 19.9775 19.0826C20.0884 19.0826 20.1886 19.1037 20.276 19.1469C20.3634 19.1901 20.4282 19.2486 20.4705 19.3235L20.3526 19.4358C20.2701 19.312 20.1454 19.2506 19.9804 19.2506C19.8282 19.2506 19.7094 19.3053 19.6249 19.4147C19.5395 19.5241 19.4973 19.6786 19.4973 19.8773C19.4973 20.076 19.5395 20.2286 19.623 20.339C19.7064 20.4494 19.8223 20.5041 19.9696 20.5041C20.06 20.5041 20.1366 20.4887 20.1984 20.459C20.2613 20.4292 20.3124 20.3822 20.3536 20.3189L20.4714 20.4312C20.4282 20.5079 20.3624 20.5665 20.275 20.6087C20.1876 20.651 20.0865 20.6721 19.9706 20.6721C19.8321 20.6721 19.7113 20.6394 19.6092 20.5751H19.6073Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6162 19.1047H21.8244V19.7842H22.5786V19.1047H22.7868V20.65H22.5786V19.9522H21.8244V20.65H21.6162V19.1047Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3963 19.264H23.9082V19.1047H25.0896V19.264H24.6045V20.65H24.3963V19.264Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2139 19.1047H26.4221V20.482H27.1851V20.65H26.2139V19.1047Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3574 19.1047H29.3061V19.2726H28.5656V19.7535H29.2275V19.9215H28.5656V20.482H29.3061V20.65H28.3574V19.1047Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7225 20.5751C30.6204 20.5108 30.5408 20.4187 30.4848 20.2987C30.4289 20.1797 30.4014 20.0386 30.4014 19.8773C30.4014 19.7161 30.4298 19.575 30.4858 19.456C30.5418 19.3369 30.6223 19.2448 30.7264 19.1795C30.8305 19.1152 30.9523 19.0826 31.0927 19.0826C31.2037 19.0826 31.3038 19.1037 31.3912 19.1469C31.4786 19.1901 31.5435 19.2486 31.5857 19.3235L31.4678 19.4358C31.3854 19.312 31.2606 19.2506 31.0957 19.2506C30.9434 19.2506 30.8246 19.3053 30.7402 19.4147C30.6547 19.5241 30.6125 19.6786 30.6125 19.8773C30.6125 20.076 30.6547 20.2286 30.7382 20.339C30.8217 20.4494 30.9376 20.5041 31.0849 20.5041C31.1752 20.5041 31.2518 20.4887 31.3137 20.459C31.3765 20.4292 31.4276 20.3822 31.4688 20.3189L31.5867 20.4312C31.5435 20.5079 31.4777 20.5665 31.3903 20.6087C31.3029 20.651 31.2017 20.6721 31.0858 20.6721C30.9474 20.6721 30.8266 20.6394 30.7245 20.5751H30.7225Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7305 19.1047H32.9387V19.7842H33.6929V19.1047H33.901V20.65H33.6929V19.9522H32.9387V20.65H32.7305V19.1047Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0586 19.9944H35.6773V20.1317H35.0586V19.9944Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9573 20.6078C36.8679 20.5656 36.7962 20.5061 36.7412 20.4312L36.8679 20.3074C36.915 20.3659 36.973 20.4139 37.0437 20.4494C37.1144 20.4859 37.1841 20.5032 37.2538 20.5032C37.3422 20.5032 37.4149 20.4811 37.4699 20.4369C37.5249 20.3928 37.5524 20.3342 37.5524 20.2623C37.5524 20.2152 37.5425 20.1739 37.5239 20.1384C37.5052 20.1029 37.4728 20.0693 37.4267 20.0357C37.3805 20.0031 37.3157 19.9666 37.2312 19.9263C37.0702 19.8495 36.9573 19.7775 36.8915 19.7084C36.8257 19.6403 36.7933 19.5606 36.7933 19.4685C36.7933 19.3504 36.8365 19.2563 36.9239 19.1863C37.0113 19.1152 37.1271 19.0807 37.2715 19.0807C37.3727 19.0807 37.465 19.1018 37.5484 19.145C37.6319 19.1882 37.6928 19.2448 37.7301 19.3168L37.5946 19.4138C37.5583 19.3619 37.5121 19.3216 37.4542 19.2919C37.3972 19.2621 37.3363 19.2477 37.2735 19.2477C37.189 19.2477 37.1222 19.2669 37.0731 19.3063C37.024 19.3456 36.9995 19.3974 36.9995 19.4637C36.9995 19.503 37.0083 19.5376 37.027 19.5654C37.0447 19.5932 37.079 19.622 37.1271 19.6528C37.1762 19.6825 37.2528 19.7238 37.3589 19.7756C37.5023 19.8447 37.6044 19.9158 37.6663 19.9887C37.7281 20.0616 37.7586 20.1471 37.7586 20.2459C37.7586 20.3294 37.737 20.4033 37.6938 20.4677C37.6506 20.532 37.5907 20.5809 37.5131 20.6164C37.4355 20.6519 37.3452 20.6692 37.243 20.6692C37.1409 20.6692 37.0447 20.6481 36.9553 20.6049L36.9573 20.6078Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1453 20.5761C39.0442 20.5118 38.9666 20.4206 38.9126 20.2997C38.8586 20.1797 38.8311 20.0386 38.8311 19.8773C38.8311 19.7161 38.8586 19.575 38.9126 19.455C38.9666 19.335 39.0442 19.2429 39.1453 19.1786C39.2465 19.1143 39.3653 19.0826 39.5018 19.0826C39.6383 19.0826 39.7571 19.1143 39.8573 19.1786C39.9574 19.2429 40.035 19.335 40.089 19.455C40.143 19.575 40.1705 19.7161 40.1705 19.8773C40.1705 20.0386 40.143 20.1806 40.089 20.2997C40.035 20.4196 39.9574 20.5118 39.8573 20.5761C39.7571 20.6404 39.6383 20.6721 39.5018 20.6721C39.3653 20.6721 39.2455 20.6404 39.1453 20.5761ZM39.7473 20.4312C39.817 20.3793 39.871 20.3064 39.9074 20.2114C39.9447 20.1163 39.9623 20.005 39.9623 19.8773C39.9623 19.7497 39.9437 19.6374 39.9074 19.5433C39.87 19.4483 39.817 19.3753 39.7473 19.3235C39.6776 19.2717 39.5961 19.2467 39.5018 19.2467C39.4075 19.2467 39.325 19.2726 39.2553 19.3235C39.1856 19.3753 39.1325 19.4483 39.0952 19.5433C39.0579 19.6383 39.0392 19.7497 39.0392 19.8773C39.0392 20.005 39.0579 20.1173 39.0952 20.2114C39.1325 20.3054 39.1865 20.3793 39.2553 20.4312C39.325 20.483 39.4065 20.5089 39.5018 20.5089C39.597 20.5089 39.6766 20.483 39.7473 20.4312Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2266 20.5377L42.0672 19.2726H41.2924V19.1047H42.3245V19.2218L41.4868 20.482H42.3539V20.65H41.2266V20.5377Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5605 19.1047H43.7687V20.65H43.5605V19.1047Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8783 20.317H45.2635L45.1575 20.65H44.9365L45.4737 19.1047H45.6681L46.2053 20.65H45.9843L45.8783 20.317ZM45.8243 20.1509L45.5709 19.3581L45.3176 20.1509H45.8233H45.8243Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3281 19.1047H47.5363V20.482H48.2993V20.65H47.3281V19.1047Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8577 21.9842L22.3176 23.5295H22.1143L21.5742 21.9842H21.7952L22.2155 23.2598L22.6358 21.9842H22.8567H22.8577Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1228 23.4556C24.0217 23.3913 23.9441 23.3001 23.8901 23.1792C23.8361 23.0592 23.8086 22.9181 23.8086 22.7568C23.8086 22.5956 23.8361 22.4545 23.8901 22.3345C23.9441 22.2145 24.0217 22.1224 24.1228 22.0581C24.224 21.9938 24.3428 21.9621 24.4793 21.9621C24.6158 21.9621 24.7346 21.9938 24.8348 22.0581C24.935 22.1224 25.0126 22.2145 25.0666 22.3345C25.1206 22.4545 25.1481 22.5956 25.1481 22.7568C25.1481 22.9181 25.1206 23.0602 25.0666 23.1792C25.0126 23.2992 24.935 23.3913 24.8348 23.4556C24.7346 23.5199 24.6158 23.5516 24.4793 23.5516C24.3428 23.5516 24.223 23.5199 24.1228 23.4556ZM24.7248 23.3107C24.7945 23.2588 24.8486 23.1859 24.8849 23.0909C24.9222 22.9958 24.9399 22.8845 24.9399 22.7568C24.9399 22.6292 24.9212 22.5169 24.8849 22.4228C24.8476 22.3278 24.7945 22.2548 24.7248 22.203C24.6551 22.1512 24.5736 22.1262 24.4793 22.1262C24.385 22.1262 24.3026 22.1521 24.2328 22.203C24.1631 22.2548 24.1101 22.3278 24.0728 22.4228C24.0354 22.5178 24.0168 22.6292 24.0168 22.7568C24.0168 22.8845 24.0354 22.9968 24.0728 23.0909C24.1101 23.1849 24.1641 23.2588 24.2328 23.3107C24.3026 23.3625 24.3841 23.3884 24.4793 23.3884C24.5746 23.3884 24.6541 23.3625 24.7248 23.3107Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3086 21.9842H26.5168V23.3616H27.2798V23.5295H26.3086V21.9842Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4502 21.9842H28.6584V23.3616H29.4214V23.5295H28.4502V21.9842Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5938 21.9842H31.5424V22.1522H30.8019V22.633H31.4638V22.801H30.8019V23.3616H31.5424V23.5295H30.5938V21.9842Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.679 23.5295L33.1753 22.7588L32.9494 23.0237V23.5295H32.7412V21.9842H32.9494V22.7501L33.5926 21.9842H33.8342L33.3128 22.5975L33.9049 23.5295H33.679Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1321 23.4873C35.0427 23.4451 34.971 23.3856 34.916 23.3107L35.0427 23.1869C35.0898 23.2454 35.1478 23.2934 35.2185 23.3289C35.2892 23.3654 35.3589 23.3827 35.4286 23.3827C35.517 23.3827 35.5897 23.3606 35.6447 23.3165C35.6997 23.2723 35.7272 23.2138 35.7272 23.1418C35.7272 23.0947 35.7174 23.0535 35.6987 23.0179C35.68 22.9824 35.6476 22.9488 35.6015 22.9152C35.5553 22.8826 35.4905 22.8461 35.406 22.8058C35.245 22.729 35.1321 22.6571 35.0663 22.5879C35.0005 22.5198 34.9681 22.4401 34.9681 22.348C34.9681 22.2299 35.0113 22.1359 35.0987 22.0658C35.1861 21.9948 35.302 21.9602 35.4463 21.9602C35.5475 21.9602 35.6398 21.9813 35.7232 22.0245C35.8067 22.0677 35.8676 22.1243 35.9049 22.1963L35.7694 22.2933C35.7331 22.2414 35.6869 22.2011 35.629 22.1714C35.572 22.1416 35.5111 22.1272 35.4483 22.1272C35.3638 22.1272 35.297 22.1464 35.2479 22.1858C35.1988 22.2251 35.1743 22.277 35.1743 22.3432C35.1743 22.3825 35.1831 22.4171 35.2018 22.4449C35.2195 22.4728 35.2538 22.5016 35.302 22.5323C35.3511 22.562 35.4277 22.6033 35.5337 22.6551C35.6771 22.7242 35.7792 22.7953 35.8411 22.8682C35.903 22.9412 35.9334 23.0266 35.9334 23.1255C35.9334 23.209 35.9118 23.2829 35.8686 23.3472C35.8254 23.4115 35.7655 23.4604 35.6879 23.4959C35.6103 23.5315 35.52 23.5487 35.4178 23.5487C35.3157 23.5487 35.2195 23.5276 35.1301 23.4844L35.1321 23.4873Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1123 21.9842H37.5778C37.7526 21.9842 37.8842 22.0235 37.9745 22.1032C38.0639 22.1829 38.1091 22.299 38.1091 22.4516C38.1091 22.6138 38.0619 22.7377 37.9686 22.8241C37.8753 22.9104 37.7408 22.9536 37.567 22.9536H37.3205V23.5295H37.1123V21.9842ZM37.5935 22.7857C37.6946 22.7857 37.7722 22.7578 37.8272 22.7022C37.8822 22.6465 37.9097 22.5668 37.9097 22.4641C37.9097 22.3614 37.8812 22.2856 37.8243 22.2318C37.7673 22.179 37.6838 22.1522 37.5758 22.1522H37.3205V22.7857H37.5935Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9271 23.1965H39.3124L39.2063 23.5295H38.9854L39.5225 21.9842H39.717L40.2541 23.5295H40.0332L39.9271 23.1965ZM39.8731 23.0304L39.6197 22.2376L39.3664 23.0304H39.8721H39.8731Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3779 21.9842H41.864C42.0359 21.9842 42.1635 22.0187 42.248 22.0869C42.3325 22.155 42.3747 22.2587 42.3747 22.3969C42.3747 22.4996 42.3482 22.587 42.2951 22.659C42.2421 22.73 42.1694 22.7789 42.0761 22.8039V22.8087C42.1076 22.8289 42.1331 22.8509 42.1527 22.874C42.1724 22.897 42.1891 22.9248 42.2028 22.9565L42.4405 23.5305H42.2166L42.0182 23.0314C41.9927 22.9671 41.9622 22.9229 41.9259 22.9008C41.8896 22.8788 41.8336 22.8682 41.757 22.8682H41.5871V23.5305H41.3789V21.9852L41.3779 21.9842ZM41.8522 22.7022C42.0673 22.7022 42.1753 22.6052 42.1753 22.4104C42.1753 22.324 42.1478 22.2587 42.0938 22.2165C42.0398 22.1742 41.9563 22.1522 41.8454 22.1522H41.5851V22.7022H41.8513H41.8522Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9373 22.1435H43.4492V21.9842H44.6306V22.1435H44.1455V23.5295H43.9373V22.1435Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7578 21.9842H46.7064V22.1522H45.966V22.633H46.6279V22.801H45.966V23.3616H46.7064V23.5295H45.7578V21.9842Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9512 21.9842H48.1594V23.5295H47.9512V21.9842Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_814_5819",
    x1: 39.6895,
    y1: 3.65507,
    x2: 42.0061,
    y2: 3.65507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_814_5819",
    x1: 38.7168,
    y1: 4.90188,
    x2: 42.423,
    y2: 4.90188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_814_5819",
    x1: 38.6426,
    y1: 5.4269,
    x2: 42.9409,
    y2: 5.4269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_814_5819",
    x1: 38.8224,
    y1: 5.7533,
    x2: 43.4752,
    y2: 5.7533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_814_5819",
    x1: 39.2179,
    y1: 6.1785,
    x2: 43.6596,
    y2: 6.1785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_814_5819",
    x1: 39.5342,
    y1: 6.84652,
    x2: 43.588,
    y2: 6.84652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_814_5819",
    x1: 39.6925,
    y1: 7.50981,
    x2: 43.6805,
    y2: 7.50981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_814_5819",
    x1: 40.1163,
    y1: 7.95323,
    x2: 43.8097,
    y2: 7.95323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_814_5819",
    x1: 40.1772,
    y1: 8.57138,
    x2: 44.0621,
    y2: 8.57138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_814_5819",
    x1: 40.5851,
    y1: 8.83244,
    x2: 44.4611,
    y2: 8.83244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_814_5819",
    x1: 39.5714,
    y1: 10.2357,
    x2: 44.7025,
    y2: 10.2357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_814_5819",
    x1: 39.8829,
    y1: 10.6897,
    x2: 44.9315,
    y2: 10.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_814_5819",
    x1: 40.2472,
    y1: 11.0391,
    x2: 45.2516,
    y2: 11.0391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_814_5819",
    x1: 40.7462,
    y1: 11.2138,
    x2: 45.6779,
    y2: 11.2138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_814_5819",
    x1: 41.2237,
    y1: 11.5162,
    x2: 45.9502,
    y2: 11.5162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_814_5819",
    x1: 41.5244,
    y1: 11.7503,
    x2: 46.4905,
    y2: 11.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_814_5819",
    x1: 41.9181,
    y1: 12.0489,
    x2: 46.8527,
    y2: 12.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_814_5819",
    x1: 42.5538,
    y1: 12.1305,
    x2: 47.2715,
    y2: 12.1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_814_5819",
    x1: 43.6222,
    y1: 11.783,
    x2: 47.8498,
    y2: 11.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_814_5819",
    x1: 44.3556,
    y1: 11.7427,
    x2: 48.3387,
    y2: 11.7427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_814_5819",
    x1: 44.9142,
    y1: 12.1688,
    x2: 48.3581,
    y2: 12.1688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_814_5819",
    x1: 45.336,
    y1: 12.7601,
    x2: 48.286,
    y2: 12.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_814_5819",
    x1: 45.7345,
    y1: 14.5713,
    x2: 46.5535,
    y2: 14.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_814_5819",
    x1: 46.1593,
    y1: 15.1789,
    x2: 46.4568,
    y2: 15.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_814_5819",
    x1: 39.7413,
    y1: 3.20489,
    x2: 42.0579,
    y2: 3.20489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_814_5819",
    x1: 38.7686,
    y1: 4.45267,
    x2: 42.4747,
    y2: 4.45267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_814_5819",
    x1: 38.6943,
    y1: 4.97677,
    x2: 42.9927,
    y2: 4.97677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_814_5819",
    x1: 38.8741,
    y1: 5.30407,
    x2: 43.5279,
    y2: 5.30407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_814_5819",
    x1: 39.2696,
    y1: 5.7283,
    x2: 43.7113,
    y2: 5.7283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_814_5819",
    x1: 39.5859,
    y1: 6.3973,
    x2: 43.6397,
    y2: 6.3973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_814_5819",
    x1: 39.7442,
    y1: 7.05961,
    x2: 43.7322,
    y2: 7.05961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_814_5819",
    x1: 40.1681,
    y1: 7.504,
    x2: 43.8615,
    y2: 7.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_814_5819",
    x1: 40.2289,
    y1: 8.12119,
    x2: 44.1138,
    y2: 8.12119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_814_5819",
    x1: 40.6368,
    y1: 8.38322,
    x2: 44.5129,
    y2: 8.38322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_814_5819",
    x1: 39.6231,
    y1: 9.78554,
    x2: 44.7542,
    y2: 9.78554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_814_5819",
    x1: 39.9347,
    y1: 10.2395,
    x2: 44.9833,
    y2: 10.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_814_5819",
    x1: 40.2989,
    y1: 10.5899,
    x2: 45.3033,
    y2: 10.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_814_5819",
    x1: 40.7979,
    y1: 10.7646,
    x2: 45.7297,
    y2: 10.7646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_814_5819",
    x1: 41.2755,
    y1: 11.0669,
    x2: 46.002,
    y2: 11.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_814_5819",
    x1: 41.5762,
    y1: 11.3002,
    x2: 46.5423,
    y2: 11.3002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_814_5819",
    x1: 41.9698,
    y1: 11.5997,
    x2: 46.9045,
    y2: 11.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_814_5819",
    x1: 42.6056,
    y1: 11.6803,
    x2: 47.3232,
    y2: 11.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_814_5819",
    x1: 43.6739,
    y1: 11.3337,
    x2: 47.9016,
    y2: 11.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_814_5819",
    x1: 44.4073,
    y1: 11.2925,
    x2: 48.3904,
    y2: 11.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_814_5819",
    x1: 44.9659,
    y1: 11.7196,
    x2: 48.4099,
    y2: 11.7196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_814_5819",
    x1: 45.3888,
    y1: 12.3099,
    x2: 48.3378,
    y2: 12.3099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_814_5819",
    x1: 45.7862,
    y1: 14.1221,
    x2: 46.6052,
    y2: 14.1221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_814_5819",
    x1: 46.211,
    y1: 14.7287,
    x2: 46.5086,
    y2: 14.7287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#25BCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3EC3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#66CFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9DDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E2F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_5819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.b7020e935eb90c98e3f936fd27e9ea99.svg";
export { ForwardRef as ReactComponent };